<app-page-layout
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Main Content Section -->
  <div class="content-wrapper">
    
    <!-- Section: Introduction -->
    <section class="main-section">
      <h2 class="section-title">Responsabilité Civile Mandataires Sociaux - RCMS</h2>
      <h3 class="section-subtitle">Assurance Responsabilité Civile des Dirigeants</h3>
      
      <p>
        Toutes les personnes ayant un poste de haute direction dans une entreprise, c'est à dire un grade de mandataire social, doivent souscrire une assurance responsabilité civile des mandataires sociaux, car en cas de faute de leur part, la responsabilité personnelle des dirigeants peut être recherchée, individuellement et solidairement. En cas de condamnation par les juridictions pénales, civiles, administratives, les dirigeants sont responsables sur leur patrimoine personnel.
      </p>

      <p class="note-text">
        Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : <strong class="purple-text">GENERALI, AXA, PROGEAS, HELVETIA, CREDIT MUTUEL, APRIL</strong>
      </p>
    </section>

    <!-- Section: Que feriez-vous si ? -->
    <section class="main-section highlighted-section">
      <h2 class="section-title purple-title">Que feriez-vous si ?</h2>
      
      <ul class="bullet-list">
        <li>Votre responsabilité était mise en cause pour une mauvaise tenue de comptabilité ?</li>
        <li>Vous faites l'objet d'une condamnation personnelle pour publicité mensongère ?</li>
        <li>Vous êtes personnellement mis en cause pour une faute de gestion telle que la déclaration tardive de la cessation de paiement et la poursuite d'une activité déficitaire ?</li>
      </ul>
    </section>

    <!-- Section: Une protection indispensable -->
    <section class="main-section highlighted-section-alt">
      <h2 class="section-title purple-title">Une protection indispensable pour protéger votre patrimoine personnel :</h2>
      
      <p>
        De plus en plus de dirigeants sont mis en cause personnellement, car la jurisprudence a élargi uniformément le champ de leur responsabilité. Au delà de la simple faute, ils peuvent être jugés responsables en cas d'omission ou de négligence dans leur gestion. Assurer son entreprise ne suffit pas, il devient indispensable pour tout dirigeant d'être assuré personnellement, afin de protéger son patrimoine personnel. La responsabilité civile des mandataires sociaux prend en charge les conséquences de la mise en jeu de votre responsabilité de dirigeant, y compris les conséquences financières qui vous incombent personnellement :
      </p>

      <ul class="bullet-list">
        <li>Les dommages et intérêts, règlements et autres frais que vous seriez tenu de payer suite à une réclamation,</li>
        <li>Les frais consécutifs à l'examen du dossier et à votre défense (frais d'enquête et d'expertise, honoraires d'avocat...).</li>
      </ul>

      <p>
        Lorsqu'il y a Accident de Travail avec dommages corporels, très souvent, la faute inexcusable de l'employeur est invoquée. Dans ce cas la sécurité sociale prend en charge l'indemnisation de la victime, dans un premier temps, avant de se retourner contre l'employeur. L'inspection du travail réalise une enquête pour déterminer la responsabilité pénale de l'employeur, car il a des dommages corporels. S'il y a responsabilité, l'employeur doit payer une amende sur ses propres ressources financières et non sur celles de l'entreprise. D'autres frais sont également payables par l'employeur, notamment les dommages et intérêts à la victime. L'assurance RCMS intervient pour prendre en charge ces frais, qui sont souvent très importants et risqueraient de mettre la situation personnelle de l'employeur dans une condition très difficile. L'assurance responsabilité civile des mandataires sociaux (Dirigeants légaux : Président, Directeur Général, Gérant, Directeur Financier, ..., Dirigeants de fait : épouse du dirigeant si elle pilote à titre temporaire l'activité, subordonné du dirigeant à qui il a attribuer une responsabilité...).
      </p>

      <p>
        La RCMS, souscrite par l'entreprise, protège les dirigeants du Passé, du Présent, et du Futur. La RCMS est complémentaire à l'<a routerLink="/assurance-rc-entreprise" class="link-purple">Assurance Responsabilité Civile</a> ou <a routerLink="/assurance-rc-entreprise" class="link-purple">Assurance Responsabilité Civile Entreprise</a>. La RCMS n'est active qu'en cas de dommage, contrairement à l'<a routerLink="/assurance-protection-juridique-pro" class="link-purple">Assurance Protection Juridique Professionnelle</a>. Une entreprise, si elle souhaite être couverte correctement doit souscrire une RC, une RCMS, et une PJ.
      </p>
    </section>

    <!-- Section: Qui peut chercher votre responsabilité ? -->
    <section class="main-section highlighted-section">
      <h2 class="section-title purple-title">Qui peut chercher votre responsabilité ?</h2>
      
      <ul class="bullet-list">
        <li>Les Salariés, pour non-respect d'une obligation de sécurité,</li>
        <li>Les Créanciers, pour poursuite d'une activité déficitaire, non-respect des échéances de remboursements d'emprunt,</li>
        <li>Les Concurrents, pour pratiques commerciales anticoncurrentielles, diffamation,</li>
        <li>Les Fournisseurs, pour retard de paiement des factures,</li>
        <li>L'Entreprise, car le nouveau dirigeant peut être mis en cause par les anciens dirigeants : Abus de biens sociaux, investissement non louable,</li>
        <li>Les Actionnaires, pour la non-tenue d'une assemblée générale dans les délais, informations financières inexactes,</li>
        <li>Les Clients, pour non-respect des règles d'hygiène,</li>
        <li>Les Pouvoirs Publics, pour non-paiement des cotisations sociales, ventes à perte.</li>
      </ul>
    </section>

    <!-- Section: Le saviez-vous ? -->
    <section class="main-section info-section">
      <h2 class="section-title red-title">Le saviez-vous ?</h2>
      
      <ul class="simple-list">
        <li>Les dirigeants peuvent avoir à supporter tout ou partie des dettes de l'entreprise.</li>
        <li>La délégation de pouvoir ne protège pas totalement le dirigeant.</li>
        <li>Il n'existe pas de définition fixe de la faute de gestion.</li>
      </ul>
    </section>

  </div>

</app-page-layout>
